import T from 'i18n-react'
import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc
} from 'helpers/ComponentSelectorUtil'
import {
  createSelector
} from 'reselect'

const valuesSelectorFunc = state => (state.values[0]) ? state.values[0].value : undefined
const sourcesSelectorFunc = state => state.sources

const valuesSelectorHoc = (valuesSelector, minSelector) => (
  createSelector(
    valuesSelector,
    minSelector,
    (value, min) => value ? value : min
  )
)

const minResultFunc = (entities, refs) => Math.min(...refs.map(({id, type}) => entities[type][id].min))
const maxResultFunc = (entities, refs) => Math.max(...refs.map(({id, type}) => entities[type][id].max))

export default (path) => {
  const withPath = createSelectorWithPath(path)

  const labelSelector = withPath(labelSelectorFunc)
  const valueSelectorWithPath = withPath(valuesSelectorFunc)
  const sourceSelectorWithPath = withPath(sourcesSelectorFunc)
  const minSelector = createSelectorWithEntity(sourceSelectorWithPath, minResultFunc)
  const maxSelector = createSelectorWithEntity(sourceSelectorWithPath, maxResultFunc)
  const valueSelector = valuesSelectorHoc(valueSelectorWithPath, minSelector)

  return {
    labelSelector,
    valueSelector,
    minSelector,
    maxSelector,
  }
}
